import { render } from "./PaymentFailed.vue?vue&type=template&id=948abacc&scoped=true&ts=true"
import script from "./PaymentFailed.vue?vue&type=script&lang=ts"
export * from "./PaymentFailed.vue?vue&type=script&lang=ts"

import "./PaymentFailed.vue?vue&type=style&index=0&id=948abacc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-948abacc"]])

export default __exports__